const Avantages=({col=3,blocks,title,text,button})=>{
 
    
return(
    <>
    <div className="d-flex flex-wrap">
       <div className="col-md-7">
         <h2 className="grey500">{title}</h2>
         {text && <p className="body grey66 mt-16">
      {text}
    </p> }
    </div>
    <div className="col-md-5 text-end">
    {button && button}
    </div>
    </div>
   
  
    <div className="row mt-24">
      {blocks.map((block, index) => (
        <div className={`col-md-${col} col-lg-${col}  mb-3`} key={index}>
          <div className="box-grey h-100 p-24">
            <img src={block.icon} alt={block.title} />
            <p className='mb-0 bold600 grey500 mt-16'>{block.title}</p>
            <p className='mb-0 mt-8'>{block.text}</p>
          </div>
        </div>
      ))}
    </div>
    </>
)
}
export default Avantages